export default "__VITE_ASSET__BwVKb_ql__"